import {
  NegativeColors,
  PositiveColors,
  PrimaryColors,
  TextColors,
} from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';
import type { ColorSchemeType } from '../../context/colorScheme';
import { DEFAULT_COLOR_SCHEME } from '../../context/colorScheme';
import { ColorSchemes } from '../../context/colorScheme/enums';

type StyleProps = {
  colorScheme: ColorSchemeType;
  isMaximizer?: boolean;
};

const useStyles = createUseStyles<string, StyleProps>(
  () => ({
    root: ({ colorScheme, isMaximizer }) => ({
      padding: isMaximizer ? Spacings.s0 : [Spacings.s72, Spacings.s0, Spacings.s0, Spacings.s0],
      backgroundColor:
        colorScheme === ColorSchemes.LIGHT
          ? PositiveColors.base.default
          : NegativeColors.base.default,
    }),
    container: ({ isMaximizer }) => ({
      textAlign: 'center',
      padding: isMaximizer ? [Spacings.s16, Spacings.s0] : [Spacings.s24, Spacings.s0],
    }),
    title: ({ colorScheme }) => ({
      color:
        colorScheme === DEFAULT_COLOR_SCHEME
          ? PositiveColors.text.default
          : NegativeColors.text.default,
    }),
    starsReviews: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: ({ isMaximizer }) => (isMaximizer ? null : [Spacings.s24, 'auto']),

      '@media screen and (max-width: 1023px)': {
        flexDirection: 'column',
      },
      '@media screen and (max-width: 768px)': {
        gap: 10,
      },
    },
    starsReviewsContainer: {
      display: 'flex',
    },
    total: ({ colorScheme }) => ({
      fontSize: FontSizes.s24,
      fontWeight: FontWeights.bold,
      color: colorScheme === DEFAULT_COLOR_SCHEME ? PrimaryColors.base.default : '#B995F3',
      margin: [Spacings.s0, Spacings.s12, Spacings.s0, Spacings.s6],

      '& > span': {
        color: colorScheme === DEFAULT_COLOR_SCHEME ? TextColors.base : PositiveColors.text.default,
        fontWeight: FontWeights.normal,
      },
    }),
    reviewsCount: ({ colorScheme }) => ({
      fontSize: FontSizes.s24,
      lineHeight: LineHeights.l32,
      color: colorScheme === DEFAULT_COLOR_SCHEME ? TextColors.tint2 : TextColors.tint3,
    }),
    stars: ({ colorScheme }) => ({
      fill: colorScheme === DEFAULT_COLOR_SCHEME ? PrimaryColors.base.default : '#B995F3',
      marginRight: Spacings.s6,
    }),
    description: ({ colorScheme }) => ({
      color: colorScheme === DEFAULT_COLOR_SCHEME ? TextColors.base : PositiveColors.text.default,
      padding: [Spacings.s0, Spacings.s16],
    }),
    button: {
      marginTop: Spacings.s24,
    },

    // SKELETON
    skeletonContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',

      '& > *': {
        borderRadius: CornerRadius.r20,
      },
    },
    skeletonTitle: {
      width: 370,
      height: 74,
    },
    skeletonRating: {
      width: 362,
      height: 32,
    },
    skeletonDescription: {
      width: 390,
      height: 100,
    },
    skeletonButton: {
      width: 120,
      height: 48,
      borderRadius: 40,
    },
  }),
  {
    name: 'rating',
  },
);

export default useStyles;
